(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kmc-b2b-order-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kmc-b2b-order-list')) {
    class KmcB2BOrderList extends HTMLElement {
      connectedCallback() {
        if (this.applyDefaultSort()) return;

        this.rows = Array.from(this.querySelectorAll('[data-order-row]'));
        this.categorySelect = this.querySelector('[data-category-select]');
        this.sortSelect = this.querySelector('[data-sort-select]');
        this.emptyState = this.querySelector('[data-empty-state]');
        this.floatingCart = this.querySelector('[data-floating-cart]');
        this.viewportUpdateQueued = false;
        this.handleViewportChange = () => this.queueFloatingPositionUpdate();

        this.sortSelect?.addEventListener('change', () => {
          this.sortSelect.form?.requestSubmit();
        });

        this.categorySelect?.addEventListener('change', () => this.filterRows());

        this.rows.forEach((row) => this.setupRow(row));
        window.addEventListener('resize', this.handleViewportChange);
        window.addEventListener('scroll', this.handleViewportChange, { passive: true });
        this.queueFloatingPositionUpdate();
        this.refreshCart();
      }

      applyDefaultSort() {
        if (this.dataset.designMode === 'true') return false;

        const currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.get('sort_by')) return false;

        const targetUrl = new URL(this.dataset.defaultSortUrl, window.location.origin);
        currentUrl.searchParams.forEach((value, key) => {
          if (key !== 'sort_by' && key !== 'page') targetUrl.searchParams.append(key, value);
        });

        window.location.replace(targetUrl.toString());
        return true;
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleViewportChange);
        window.removeEventListener('scroll', this.handleViewportChange);
      }

      queueFloatingPositionUpdate() {
        if (this.viewportUpdateQueued) return;
        this.viewportUpdateQueued = true;

        window.requestAnimationFrame(() => {
          this.viewportUpdateQueued = false;
          this.updateFloatingPosition();
        });
      }

      updateFloatingPosition() {
        if (!this.floatingCart?.classList.contains('kmc-b2b-order__floating--mobile-below_header')) return;
        if (!window.matchMedia('(max-width: 749px)').matches) {
          this.style.removeProperty('--kmc-b2b-mobile-checkout-top');
          return;
        }

        const stickyHeader = document.querySelector('.shopify-section-header-sticky, sticky-header');
        const headerBottom = stickyHeader ? Math.max(0, stickyHeader.getBoundingClientRect().bottom) : 0;
        this.style.setProperty('--kmc-b2b-mobile-checkout-top', `${headerBottom + 8}px`);
      }

      setupRow(row) {
        const minus = row.querySelector('[data-quantity-minus]');
        const plus = row.querySelector('[data-quantity-plus]');
        const input = row.querySelector('[data-quantity-input]');
        const addButton = row.querySelector('[data-add-button]');

        if (!minus || !plus || !input || !addButton) return;

        minus.addEventListener('click', () => {
          const current = this.normaliseQuantity(input, Number.parseInt(input.value, 10) || 0);
          const minimum = this.number(input.dataset.minimum, 1);
          const increment = this.number(input.dataset.increment, 1);
          input.value = current <= minimum ? 0 : Math.max(minimum, current - increment);
          this.updateRowControls(row);
        });

        plus.addEventListener('click', () => {
          const current = this.normaliseQuantity(input, Number.parseInt(input.value, 10) || 0);
          const minimum = this.number(input.dataset.minimum, 1);
          const increment = this.number(input.dataset.increment, 1);
          const maximum = this.maximum(input.dataset.maximum);
          const next = current === 0 ? minimum : current + increment;
          input.value = Math.min(maximum, next);
          this.updateRowControls(row);
        });

        input.addEventListener('change', () => {
          input.value = this.normaliseQuantity(input, Number.parseInt(input.value, 10) || 0);
          this.updateRowControls(row);
        });

        input.addEventListener('blur', () => {
          input.value = this.normaliseQuantity(input, Number.parseInt(input.value, 10) || 0);
          this.updateRowControls(row);
        });

        addButton.addEventListener('click', () => this.addRow(row));
        this.updateRowControls(row);
      }

      number(value, fallback) {
        const parsed = Number.parseInt(value, 10);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
      }

      maximum(value) {
        const parsed = Number.parseInt(value, 10);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : Number.POSITIVE_INFINITY;
      }

      normaliseQuantity(input, requested) {
        if (!requested || requested <= 0) return 0;

        const minimum = this.number(input.dataset.minimum, 1);
        const increment = this.number(input.dataset.increment, 1);
        const maximum = this.maximum(input.dataset.maximum);
        const bounded = Math.min(maximum, Math.max(minimum, requested));
        const steps = Math.ceil((bounded - minimum) / increment);
        return Math.min(maximum, minimum + steps * increment);
      }

      updateRowControls(row) {
        const minus = row.querySelector('[data-quantity-minus]');
        const plus = row.querySelector('[data-quantity-plus]');
        const input = row.querySelector('[data-quantity-input]');
        const addButton = row.querySelector('[data-add-button]');
        const quantity = Number.parseInt(input?.value, 10) || 0;
        const maximum = this.maximum(input?.dataset.maximum);

        if (minus) minus.disabled = quantity === 0;
        if (plus) plus.disabled = quantity >= maximum;
        if (addButton) addButton.disabled = quantity === 0 || addButton.dataset.busy === 'true';
      }

      async addRow(row) {
        const input = row.querySelector('[data-quantity-input]');
        const addButton = row.querySelector('[data-add-button]');
        const status = row.querySelector('[data-row-status]');
        const rowCheckout = row.querySelector('[data-row-checkout]');
        const variantId = row.dataset.variantId;
        const quantity = this.normaliseQuantity(input, Number.parseInt(input.value, 10) || 0);

        if (!variantId || quantity === 0 || addButton.dataset.busy === 'true') return;

        addButton.dataset.busy = 'true';
        addButton.disabled = true;
        addButton.textContent = addButton.dataset.addingLabel;
        status.textContent = '';
        status.classList.remove('is-error');

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity }]
            })
          });
          const payload = await response.json();

          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Unable to add this item.');
          }

          input.value = 0;
          addButton.textContent = addButton.dataset.addedLabel;
          status.textContent = '';
          rowCheckout?.classList.remove('hidden');
          await this.refreshCart();

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { source: 'kmc-b2b-order-list', cart: payload }
          }));
        } catch (error) {
          status.textContent = error.message;
          status.classList.add('is-error');
          addButton.textContent = addButton.dataset.addLabel;
        } finally {
          window.setTimeout(() => {
            addButton.dataset.busy = 'false';
            addButton.textContent = addButton.dataset.addLabel;
            this.updateRowControls(row);
          }, 900);
        }
      }

      async refreshCart() {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart.js', {
            headers: { Accept: 'application/json' }
          });

          if (!response.ok) return;

          const cart = await response.json();
          const count = this.querySelector('[data-cart-count]');
          const total = this.querySelector('[data-cart-total]');

          if (count) count.textContent = cart.item_count;
          if (total) total.textContent = this.formatMoney(cart.total_price, cart.currency);
          this.updateMinimumOrderStatus(cart);
          this.floatingCart?.classList.toggle('hidden', cart.item_count === 0);
          this.queueFloatingPositionUpdate();
        } catch (error) {
          // The row add remains successful even if the floating summary cannot refresh.
        }
      }

      updateMinimumOrderStatus(cart) {
        const status = this.querySelector('[data-minimum-order-status]');
        const minimum = Number(this.floatingCart?.dataset.minimumOrderCents) || 0;
        if (!status || minimum <= 0) return;

        const subtotal = Number(cart.items_subtotal_price ?? cart.total_price) || 0;
        const unlocked = subtotal >= minimum;
        status.classList.toggle('is-unlocked', unlocked);

        if (unlocked) {
          status.textContent = status.dataset.unlockedLabel;
          return;
        }

        const minimumText = this.formatMoney(minimum, cart.currency);
        const remainingText = this.formatMoney(Math.max(0, minimum - subtotal), cart.currency);
        status.textContent = `${status.dataset.minimumLabel} ${minimumText} · ${remainingText} ${status.dataset.remainingLabel}`;
      }

      formatMoney(cents, currency) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
            style: 'currency',
            currency: currency || this.dataset.moneyCurrency || 'GBP'
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return ((Number(cents) || 0) / 100).toFixed(2);
        }
      }

      filterRows() {
        const category = this.categorySelect?.value || '';
        let visible = 0;

        this.rows.forEach((row) => {
          const show = category === '' || row.dataset.category === category;
          row.hidden = !show;
          if (show) visible += 1;
        });

        this.emptyState?.classList.toggle('hidden', visible > 0);
      }
    }

    customElements.define('kmc-b2b-order-list', KmcB2BOrderList);
  }

  } catch(e) { console.error(e); }
})();
})();
